export const stripHtml = (html: string) => {
    const tagsToStrip = [`p`, `span`];

    for (const tag of tagsToStrip) {
        html = html.replaceAll(`<${tag}>`, ``);
        html = html.replaceAll(`</${tag}>`, ``);
    }
    return html;
};

export const stripHTMLStrings = (html: string) => {
    if (!html || html === ``) return ``;
    else html = html.toString();
    return html.replace(/(<([^>]+)>)/gi, ``).trim();
};

export const DOMParseHTMLElement = (htmlString: string) => {
    let parsedElement = null;
    if (typeof window !== `undefined`) {
        const parser = new window.DOMParser();
        parsedElement = parser.parseFromString(htmlString, `text/html`);
    }
    return parsedElement;
};
